import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.to && !isLast ? (
              <Link to={item.to} className="hover:text-primary-700 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-foreground-900' : ''}>{item.label}</span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
          </span>
        );
      })}
    </nav>
  );
}